import { render, staticRenderFns } from "./editorShop.vue?vue&type=template&id=0fbca7c4"
import script from "./editorShop.vue?vue&type=script&lang=js"
export * from "./editorShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports